<template>
    <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog title="申请表导出" :visible.sync="dialogVisible" width="900px">
            <span>
                <el-form>
                    <div style="width: 100%" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                <tbody>
                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'className'" class="field">申请类型</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <el-select v-model="type" placeholder="请选择" style="width: 100%">
                                                <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                            </el-select>
                                        </td>
                                    </tr>
                                    <tr v-if="type === ''">
                                        <td ref="tdlbl_班级" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="''" class="field">班级</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <span>请先选择申请类型！</span>
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'className'" class="field">班级</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                key="class"
                                                ref="className"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: 1,
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 1,
                                                    elementType: 'input',
                                                    emptyMessage: '请选择班级',
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: '',
                                                    passenger: {},
                                                    propComment: '班级',
                                                    propName: 'className',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'formData.className',
                                                    option: [],
                                                    dialog: 1,
                                                    dialogType: 'listpage',
                                                    dialogMultiple: false,
                                                    dialogListviewurl: 'school.clazz.list_YReWtN?filter='+type,
                                                    dialogTitle: '选择班级'
                                                }"
                                                :vo="vo"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </span>
            <div style="color: #1a82e3; margin-top: 8px" v-if="false">
                <i class="el-icon-warning" style="margin-right: 4px"></i>
                没有选择班级时默认导出申请类型下的所有申请表；如需导出某个班级的申请表，请选择班级进行筛选操作。
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmClick">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            formData: {
                className: '',
                majorId: ''
            },
            type: '',
            major: '',
            yearList: [],
            majorList: [],
            urlsearch: '',
            isShow: true,
            vo: {},
            typeList: [
                {
                    label: '免学费申请',
                    value: '免学费申请'
                },
                {
                    label: '国家助学金申请',
                    value: '国家助学金申请'
                },
                {
                    label: '经济困难认定表',
                    value: '经济困难认定表'
                }
            ]
        }
    },
    computed: {},
    created() {
        console.log('bathEditDialog--------')
        this.$bus.on('openAddRecord', this.openAddRecord)
    },
    beforeDestroy() {
        this.$bus.off('openAddRecord', this.openAddRecord)
    },
    mounted() {
        // let roles = this.$store.getters.roles
        // this.urlsearch = ''
        // if (roles.indexOf('dwAdministrators') === -1) {
        //     this.urlsearch = 'teacherId:' + this.$store.getters.loginUser.personId
        // }
    },
    methods: {
        changeMajor(val) {
            this.formData.majorId = val
        },
        openAddRecord() {
            this.type = ''
            this.dialogVisible = true
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: `/xsgl/exportLog/addNew`
            }).then((res) => {
                if (res.code === 'success') {
                    this.vo = res.body.vo
                }
            })
        },

        confirmClick() {
            if (this.type == '') {
                this.$message.warning('请选择申请类型')
                return
            }
            this.vo.exportModule = this.type
            this.formValidate(
                () => {
                    this.$http({
                        method: 'POST',
                        contentType: 'application/x-www-form-urlencoded',
                        data: this.vo,
                        url: `/xsgl/exportLog/insert`
                    }).then((res) => {
                        if (res.code === 'success') {
                            // this.insert(res.body.vo)
                            this.$message.success('提交成功')
                            this.dialogVisible = false
                            this.$bus.emit('refreshListData')
                        }
                    })
                },
                null,
                1
            )
        },
        onSelectListpageRowCompleted: function (val, arr) {
            const item = val[0]
            const { name } = arr
            if (name === 'majorName') {
                this.formData.majorName = item.majorName
                this.formData.majorId = item.id
            } else if (name === 'className') {
                this.vo.className = item.className
                this.vo.classId = item.classId
                // this.formData.majorName = item.passenger.majorName
                // this.formData.majorId = item.passenger.majorNameId
            }
            console.log(item)
        }
    }
}
</script>

<style></style>
